import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3030/api',
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const sessionId = localStorage.getItem('sessionId');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (sessionId) config.headers.sessionid = sessionId;
  return config;
});

client.interceptors.response.use((response) => {
  if (!response.data?.success && response.data?.result?.error?.includes('Session Expired')) {
    console.log('Session expired, logging out...');
    localStorage.removeItem('token');
    localStorage.removeItem('sessionId');
    window.location.href = '/login';
  }
  return response;
})

// Backend always answers HTTP 200 with {success, result:{message|error}} —
// unwrap that shape so callers can just await a plain value or catch an Error.
export async function apiCall(promise) {
  const { data } = await promise;
  if (data.success) {
    return data.result.message;
  }
  throw new Error(data.result?.error || 'Something went wrong.');
}

export default client;
